import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md-progress-bar md-indeterminate md-theme-demo-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "md-progress-bar-track" }, null, -1),
    _createElementVNode("div", { class: "md-progress-bar-fill" }, null, -1),
    _createElementVNode("div", { class: "md-progress-bar-buffer" }, null, -1)
  ]))]))
}